import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — moves window to top on route change
 * This ensures each page renders from the top instead of preserving the
 * previous scroll position when a user navigates between routes.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll instantly to top on route change — ensures new pages are shown from start
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
